// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedRotating_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.25 2.22656C7.25 2.91692 6.69036 3.47656 6 3.47656 5.30964 3.47656 4.75 2.91692 4.75 2.22656 4.75 1.53621 5.30964.976562 6 .976562 6.69036.976562 7.25 1.53621 7.25 2.22656ZM3 6 1.5 4 0 6H1C1 6.83204 1.20323 7.61662 1.56277 8.30679L2.40475 7.7554C2.14551 7.22545 2 6.62972 2 6H3ZM9 6 10.5 8 12 6H11C11 5.16715 10.7964 4.38186 10.4362 3.69119L9.59424 4.24255C9.85411 4.77302 10 5.36947 10 6L9 6ZM6 11C6.69036 11 7.25 10.4404 7.25 9.75 7.25 9.05964 6.69036 8.5 6 8.5 5.30964 8.5 4.75 9.05964 4.75 9.75 4.75 10.4404 5.30964 11 6 11ZM7.25 6C7.25 6.69036 6.69036 7.25 6 7.25 5.30964 7.25 4.75 6.69036 4.75 6 4.75 5.30964 5.30964 4.75 6 4.75 6.69036 4.75 7.25 5.30964 7.25 6ZM3.5 10.3311V9.12269C3.30128 8.96338 3.11808 8.7855 2.95306 8.59168L2.11115 9.14302C2.4963 9.61897 2.96706 10.0228 3.5 10.3311ZM9.04546 3.40659 9.88742 2.85522C9.50253 2.38003 9.03228 1.97682 8.5 1.66891V2.87731C8.69813 3.03614 8.88082 3.21344 9.04546 3.40659Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedRotating is a generated icon component.
 */
let IconMedRotating = IconMedRotating_1 = class IconMedRotating extends IconBaseElement {
    render() {
        return html `${IconMedRotating_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedRotating.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s12IconSvg],
    ['s24', _s12IconSvg],
    ['s32', _s12IconSvg],
    ['s40', _s12IconSvg],
    ['s48', _s12IconSvg],
    ['s64', _s12IconSvg],
    ['s72', _s12IconSvg],
    ['s80', _s12IconSvg],
]);
IconMedRotating = IconMedRotating_1 = __decorate([
    customElement('zui-icon-med-rotating')
], IconMedRotating);
export { IconMedRotating };
